import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Table from '../components/Table';
import ModalDelete from '../components/ModalDelete';
import ModalAddCategory from '../components/ModalAddCategory';
import ModalEditCategory from '../components/ModalEditCategory';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';
import SearchBar from '../components/Searchbar';

//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const Categorias = ({ onMenuSelect }) => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState('categorias');
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ name: '' });

  // Filter categories based on search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredCategories(categories);
    } else {
      const filtered = categories.filter(category => 
        category.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        category.id?.toString().includes(searchTerm)
      );
      setFilteredCategories(filtered);
    }
  }, [categories, searchTerm]);

  // Fetch categories from API
  const fetchCategories = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${IP}items/categories`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setCategories(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleDeleteCategory = (categoryId) => {
    const category = categories.find(c => c.id === categoryId);
    setCategoryToDelete(category);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${IP}items/delete-category?category_id=${categoryToDelete.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success' && result.data.message === 'Category deactivated successfully (soft delete)') {
          console.log('Category deleted successfully');
          setShowDeleteModal(false);
          setCategoryToDelete(null);
          fetchCategories();
        }
      } else {
        throw new Error('Error al eliminar la categoría');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  };

  const handleAddCategory = async (categoryData) => {
    try {
      const url = `${IP}items/add-category?description_category=${encodeURIComponent(categoryData.name)}` + 
                  (categoryData.img_item ? `&img_item=${encodeURIComponent(categoryData.img_item)}` : '');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          // Check if category was actually inserted or already exists
          if (result.data.message === 'Category inserted successfully') {
            console.log('Category created successfully');
          } else if (result.data.message === 'Category not inserted. Exists in database') {
            console.log('Category already exists');
            // You could show a warning message to the user here if needed
          }
          
          setShowAddModal(false);
          fetchCategories();
        }
      } else {
        throw new Error('Error al crear la categoría');
      }
    } catch (error) {
      console.error('Error creating category:', error);
    }
  };

  const handleEditCategory = (category) => {
    setCategoryToEdit(category);
    setShowEditModal(true);
  };

  const handleSaveEdit = async (categoryData) => {
    if (!categoryData.name.trim()) return;

    try {
      const response = await fetch(`${IP}items/update-category-data?category_id=${categoryToEdit.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: categoryData.name, img_item: categoryData.img_item })
      });

      if (response.ok) {
        setShowEditModal(false);
        setCategoryToEdit(null);
        fetchCategories();
      } else {
        throw new Error('Error al actualizar la categoría');
      }
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  const handleMenuSelect = (menuId) => {
    setSelectedMenu(menuId);
    if (onMenuSelect) {
      onMenuSelect(menuId);
    }
  };

  const columns = [
    { key: 'id', title: 'ID', width: '80px' },
    {
      key: 'img_item',
      title: 'Imagen',
      width: '80px',
      render: (_, item) => (
        item.img_item ? (
          <img src={item.img_item} alt={item.name} className="w-10 h-10 object-cover rounded" />
        ) : (
          <div className="w-10 h-10 bg-gray-200 rounded flex items-center justify-center text-gray-500">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
          </div>
        )
      )
    },
    { key: 'name', title: 'Nombre', width: '300px' },
    {
      key: 'acciones',
      title: 'Acciones',
      align: 'center',
      width: '120px',
      render: (_, item) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleEditCategory(item);
            }}
            className="text-blue-500 hover:text-blue-700 transition-colors p-1"
            title="Editar categoría"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteCategory(item.id);
            }}
            className="text-red-500 hover:text-red-700 transition-colors p-1"
            title="Eliminar categoría"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar 
        onMenuSelect={handleMenuSelect}
        activeMenu={selectedMenu}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Categorías</h1>
              <p className="text-gray-600 mt-1">Administra las categorías de productos</p>
            </div>
            <div className="flex items-center space-x-4">
              <SearchBar
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Buscar categorías..."
                className="w-80"
                disabled={isLoading}
              />
              <BlackButton onClick={() => setShowAddModal(true)}>
                + Agregar Categoría
              </BlackButton>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-auto p-6">
          <div className="bg-white rounded-lg shadow-sm">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Cargando categorías...</div>
              </div>
            ) : (
              <>
                {searchTerm && (
                  <div className="px-6 py-3 border-b border-gray-200 bg-gray-50">
                    <p className="text-sm text-gray-600">
                      {filteredCategories.length} resultado(s) para "{searchTerm}"
                      {filteredCategories.length !== categories.length && (
                        <span className="ml-2 text-gray-500">
                          de {categories.length} total(es)
                        </span>
                      )}
                    </p>
                  </div>
                )}
                <Table 
                  columns={columns}
                  data={filteredCategories}
                  emptyMessage={
                    searchTerm 
                      ? `No se encontraron categorías que coincidan con "${searchTerm}"` 
                      : "No hay categorías disponibles"
                  }
                />
              </>
            )}
          </div>
        </main>
      </div>

      {/* Modals */}
      <ModalAddCategory
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSave={handleAddCategory}
      />

      <ModalEditCategory
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setCategoryToEdit(null);
        }}
        onSave={handleSaveEdit}
        category={categoryToEdit}
      />

      {showDeleteModal && (
        <ModalDelete
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
          productName={categoryToDelete?.name}
        />
      )}
    </div>
  );
};

export default Categorias;